import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'mdi:person-multiple',
      order: 50,
      title: 'TT业务管理',
    },
    name: 'AdTTBusiness',
    path: '/TT-business',
    children: [
      {
        name: 'AdTTAccount',
        path: '/tt-account',
        component: () => import('#/views/TT-business/account-list/index.vue'),
        meta: {
          icon: 'mdi:account-outline',
          title: '账户管理',
          keepAlive: true,
        },
      },
      {
        name: 'AdTTApplyAccount',
        path: '/tt-apply-account',
        component: () =>
          import('#/views/TT-business/apply-account-list/index.vue'),
        meta: {
          icon: 'mdi:account-add-outline',
          title: '开户管理',
          keepAlive: true,
        },
      },
      {
        name: 'AdTTAccountAssign',
        path: '/tt-account-assign',
        component: () =>
          import('#/views/TT-business/account-assign-list/index.vue'),
        meta: {
          icon: 'mdi:share-variant-outline',
          title: '账户分配',
          keepAlive: true,
        },
      },
      {
        name: 'AdTTAccountRecharge',
        path: '/tt-account-recharge',
        component: () =>
          import('#/views/TT-business/account-recharge/index.vue'),
        meta: {
          icon: 'mdi:account-multiple-plus-outline',
          title: '账户充值',
          keepAlive: true,
        },
      },
      {
        name: 'AdTTAccountSubtraction',
        path: '/tt-account-subtraction',
        component: () =>
          import('#/views/TT-business/account-subtraction/index.vue'),
        meta: {
          icon: 'mdi:account-minus-outline',
          title: '账户减款',
          keepAlive: true,
        },
      },
      {
        name: 'AdTTAccountClear',
        path: '/tt-account-clear',
        component: () => import('#/views/TT-business/account-clear/index.vue'),
        meta: {
          icon: 'mdi:clear-circle-multiple',
          title: '账户清零',
          keepAlive: true,
        },
      },
      {
        name: 'AdTTServiceFeeConfig',
        path: '/tt-service-fee-config',
        component: () =>
          import('#/views/TT-business/service-fee-config/index.vue'),
        meta: {
          icon: 'mdi:settings-outline',
          title: '服务费配置',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
